import { FeatureFlagsProvider } from '@contexts/FeatureFlagsContext';
import { useAppDispatch, useAppSelector } from '@hooks/generic';
import { useAuthMeQuery } from '@services/auth';
import { changeLocale } from '@store/translationSlice';
import { useEffect, useRef } from 'react';
import { IntlProvider } from 'react-intl';
import { Views } from './routes/Views';
import { ToastContainer } from 'react-toastify';

function App() {
    const title = useAppSelector((state) => state.app.title);
    const locale = useAppSelector((state) => state.translation.locale);
    const messages = useAppSelector((state) => state.translation.messages);

    const dispatch = useAppDispatch();
    const { data: user, isFetching, isLoading } = useAuthMeQuery();
    const lastLocaleSyncKey = useRef<string | null>(null);

    useEffect(() => {
        if (isLoading || isFetching) {
            return;
        }

        const targetLocale = user?.language || locale;
        const syncKey = user ? `user:${user.language ?? targetLocale}` : `anonymous:${targetLocale}`;
        if (lastLocaleSyncKey.current === syncKey) {
            return;
        }

        lastLocaleSyncKey.current = syncKey;
        dispatch(changeLocale({ locale: targetLocale }));
    }, [dispatch, isFetching, isLoading, locale, user]);

    return (
        <FeatureFlagsProvider>
            <IntlProvider locale={locale} messages={messages} defaultLocale="en">
                <title>{title}</title>
                <Views />
                <ToastContainer />
            </IntlProvider>
        </FeatureFlagsProvider>
    );
}

export { App };
